import moment, { Moment } from 'moment';

// 定义接口
export interface DateShortcutType {
  name: string;
  nameCN: string;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}

// 获取前四个季度
const getPreviousFourQuartersWithDates = () => {
  const currentQuarter = moment().quarter();
  const quarters = [];

  for (let i = 0; i < 4; i++) {
    let quarterStart, quarterEnd;
    const quarter = currentQuarter - i - 1;
    if (quarter < 1) {
      // 计算上一个季度的起始和结束日期，跨越年份的情况处理
      quarterStart = moment().subtract((i + 1) * 3, 'months').startOf('quarter');
      quarterEnd = moment().subtract((i + 1) * 3, 'months').endOf('quarter');
    } else {
      // 计算上一个季度的起始和结束日期，不跨越年份的情况处理
      quarterStart = moment().subtract((quarter - 1) * 3, 'months').startOf('quarter');
      quarterEnd = moment().subtract((quarter - 1) * 3, 'months').endOf('quarter');
    }
    quarters.push({ start: quarterStart, end: quarterEnd });
  }
  if (Array.isArray(quarters) && quarters?.length === 4) {
    return [quarters[3]?.start, quarters[0]?.end]
  }
  return ['', ''];
}

// const lastFourQuarters = getLastFourQuarters();

export const shortcutOption = (startOfTime: string, latestDate: any, allowRange?: any): ShortcutOptionType => {
  const { date, month, week } = latestDate;
  const last4QuartersValue = getPreviousFourQuartersWithDates();
  return {
    date: [
      {
        name: 'Latest Data2',
        nameCN: '最新数据',
        onClick: () => [moment(date), moment(date)],
      },
      {
        name: 'Last 7 Days',
        nameCN: '最近7天',
        onClick: () => [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
      },
      {
        name: 'Last 30 Days',
        nameCN: '最近30天',
        onClick: () => [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
      },
      {
        name: 'Last 90 Days',
        nameCN: '最近90天',
        onClick: () => [moment().subtract(90, 'day'), moment().subtract(1, 'day')],
      },
      {
        name: 'Last 180 Days',
        nameCN: '最近180天',
        onClick: () => [moment().subtract(180, 'day'), moment().subtract(1, 'day')],
      },
      {
        name: 'Last 365 Days',
        nameCN: '最近365天',
        onClick: () => [moment().subtract(365, 'day'), moment().subtract(1, 'day')],
      },
      {
        name: 'Year to Date',
        nameCN: '今年',
        onClick: () => [moment().startOf('year'), moment()],
      },
      {
        name: 'All of time',
        nameCN: '所有时间',
        onClick: () => [moment(startOfTime), moment()],
      },
    ],
    week: [
      {
        name: 'Latest Data',
        nameCN: '最新数据',
        onClick: () => [moment(week).weekday(0), moment(week).weekday(6)],
      },
      {
        name: 'Last 4 Weeks',
        nameCN: '最近4周',
        onClick: () => [moment().weekday(-7 * 4), moment().weekday(-1)],
      },
      {
        name: 'Last 12 Weeks',
        nameCN: '最近12周',
        onClick: () => [moment().weekday(-7 * 12), moment().weekday(-1)],
      },
      {
        name: 'Last 24 Weeks',
        nameCN: '最近24周',
        onClick: () => [moment().weekday(-7 * 24), moment().weekday(-1)],
      },
      {
        name: 'Year to Date',
        nameCN: '今年',
        onClick: () =>
          // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
          [moment().startOf('year').startOf('week'), moment().weekday(6)]
        ,
      },
      {
        name: 'All of time',
        nameCN: '所有时间',
        onClick: () => [moment(startOfTime).startOf('week'), moment().weekday(6)],
      },
    ],
    month: [
      {
        name: 'Last 3 Months',
        nameCN: '最近3个月',
        onClick: () => [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
      {
        name: 'Last 6 Months',
        nameCN: '最近6个月',
        onClick: () => [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
      {
        name: 'Last 12 Months',
        nameCN: '最近12个月',
        onClick: () => [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
      {
        name: 'Last 24 Months',
        nameCN: '最近24个月',
        onClick: () => [moment().subtract(24, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
      {
        name: 'All of time',
        nameCN: '所有时间',
        onClick: () => Array.isArray(allowRange) && allowRange?.length > 1
          ? allowRange
          : [moment(startOfTime), moment().endOf('month')],
      },
    ],
    quarter: [
      {
        name: 'Last 4 Quarters',
        nameCN: 'Last 4 Quarters',
        // onClick: () => [moment().year(year).quarter(quarter).startOf('quarter'), moment().subtract(1, 'month').endOf('month')],
        onClick: () => last4QuartersValue,
      },
      {
        name: 'All of Time',
        nameCN: 'All of Time',
        onClick: () => Array.isArray(allowRange) && allowRange?.length > 1
          ? allowRange
          : [moment(startOfTime), moment().endOf('month')],
      },
    ],
    year: [
      {
        name: 'Last 5 Years',
        nameCN: 'Last 5 Years',
        onClick: () => [moment().subtract(4, 'years').startOf('year'), moment().subtract(0, 'years').endOf('year')],
      },
      {
        name: 'All of Time',
        nameCN: 'All of Time',
        onClick: () => Array.isArray(allowRange) && allowRange?.length > 1
          ? allowRange
          : [moment(startOfTime), moment().endOf('month')],
      },
    ],
    monthlyCalendar: [
      {
        name: 'Last 4 Months',
        nameCN: '最近4个月',
        onClick: () => [moment().subtract(4, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
    ],
  };
};
